import { render, staticRenderFns } from "./Internal.vue?vue&type=template&id=585c808c&lang=pug"
import script from "./Internal.vue?vue&type=script&lang=js"
export * from "./Internal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports